<template>
  <div>
    <h3 class="color-darkblue">Non-OEM Parts</h3>
    <div class="table-responsive-sm mt-4">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col">Part</th>
            <th scope="col">Description</th>
            <th scope="col" class="text-right required">Quantity</th>
            <th scope="col" class="text-right required">Unit Price (USD)</th>
            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-right">Attachment</th>
            <th scope="col"> Action </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in oem_rows" :key="index">
            <td>
              <v-select v-model="row.part" name="part" placeholder="Select Part." label="text" :options="nonOemPartArr">
              </v-select>
              <div class="field-error">{{ row.part_error_msg }}</div>

            </td>
            <td v-if="row.part != undefined && row.part.value == 'other'">
              <input type="text" placeholder="Description" v-model="row.description" style="width:99% !important"
                :id="'description' + index" :name="'description' + index" class="vgt-input text-right require">
              <div class="field-error">{{ row.description_error_message }}</div>
            </td>
            <td v-else>
              <input type="text" placeholder="Description" v-model="row.description" style="width:99% !important"
                :id="'description' + index" :name="'description' + index" class="vgt-input text-right">
              <div class="field-error">{{ row.description_error_message }}</div>
            </td>
            <td>
              <input type="number" placeholder="Quantity" v-model="row.qty" :id="'qty' + index"
                style="width:99% !important" :name="'qty' + index" class="vgt-input text-right"
                v-on:keyup="calculateNonOemPartRowTotal(index)">
              <div class="field-error">{{ row.qty_error_msg }}</div>

            </td>


            <td>
              <input type="number" placeholder="Unit Price" v-model="row.unit_price" :id="'unit_price' + index"
                :name="'unit_pricce' + index" style="width:99% !important" class="vgt-input text-right"
                v-on:keyup="calculateNonOemPartRowTotal(index)">
              <div class="field-error">{{ row.unit_price_error_msg }}</div>
            </td>
            <td>
              <input type="text" disabled placeholder="Invoice" v-model="row.invoice" id="invoice" name="invoice"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <template v-if="row.attachmentPath == null || row.attachmentPath == ''">
                <input type="file" id="Total" name="partAttachment"
                  @change="event => nonOemPartAttachmentUpload(index, event)" class="vgt-input text-right"
                  style="width:99% !important" ref="partAttachment">
                <div class="field-error">{{ row.attachmentError }}</div>
                <button class="btn btn-primary" id="uploadButton" style="margin: 4px;"
                  v-on:click.prevent="uploadAttachment('nonOemPartAttachment', index)">
                  <i class="fp-upload"> </i> Upload
                </button>
              </template>
              <template v-else>
                <i v-if="row.attachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                <i v-if="row.attachmentPath.extension == 'doc' || row.attachmentPath.extension == 'docs'"
                  class="fp-text-document"></i>
                <i v-if="row.attachmentPath.extension == 'jpg'
                  ||
                  row.attachmentPath.extension == 'png'
                  ||
                  row.attachmentPath.extension == 'jpeg'"
                  class="fp-image"
                >
                </i>
                <a title='View File' href="javascript:void(0)"
                  v-on:click="openDocument(row.attachmentPath.url, row.attachmentPath.extension)"
                  v-bind:key="'fileName' + index" style="color: #098de1;">
                  Attached File.{{ row.attachmentPath.extension }}
                </a>
                <button type="button" v-bind:key="'cancelBtn' + index"
                  v-on:click="deleteAttachment(index, 'nonOemPartAttachment');" style="margin-left: 9px;">
                  <i class="fp-close" style="color: #e30000;"></i>
                </button>
              </template>
            </td>
            <td class="text-center valign-middle">
              <template v-if="oem_rows.length != 1">
                <a href="javascript:void(0);" v-on:click="removeOemItem(index);"> <i class="fp-remove"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <button type="submit" v-on:click.prevent="addOemRow()" class="btn btn-primary">
        <i class="fp-add"></i> Add non-oem item
      </button>
      <button type="button"
        v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvNonOemLineItemsSection",
  props: ["lineItemData", "claimId", "hideEditSection", "totalClaimAmount","nonOemPartClaimAmountTotalProp"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    oem_rows: [],
    nonOemPartArr:[
      {value:'liquid gasket',text:'Liquid Gasket'},
      {value:'grease',text:'Grease'},
      {value:'oil',text:'Oil'},
      {value:'coolant',text:'Coolant'},
      {value:'zip ties',text:'Zip Ties'},
      {value:'other',text:'Other'}
    ],
    netTotalAmount: 0,
    nonOemPartClaimAmountTotal: 0,
  }),
  created() {
    this.populateData();
  },
  methods: {
    calculateNonOemPartRowTotal(index){
      this.oem_rows[index].invoice = 0;
      this.oem_rows[index].attachmentError = "";
      this.oem_rows[index].attachmentRequired = false;

      if(this.oem_rows[index].qty > 0 || this.oem_rows[index].unit_price > 0){
        if(this.oem_rows[index].unit_price > 10){
          this.oem_rows[index].attachmentRequired = true;
          if(this.oem_rows[index].attachment == null ){
            this.oem_rows[index].attachmentError = "Attachment Required!";
          }
        }
        this.oem_rows[index].invoice = this.oem_rows[index].qty * this.oem_rows[index].unit_price;
      }
      this.calculateTotalNonOemPartAmount();
    },
    calculateTotalNonOemPartAmount(){
      this.nonOemPartClaimAmountTotal = 0;
      for (let oemPart of this.oem_rows){
        if( typeof oemPart.invoice === 'string'){
          oemPart.invoice = parseFloat(oemPart.invoice);
        }
        this.nonOemPartClaimAmountTotal = this.nonOemPartClaimAmountTotal +  oemPart.invoice;
      }
      this.calculateTotalClaimAmount();
    },
    calculateTotalClaimAmount() {
      this.netTotalAmount = this.totalClaimAmount +  this.nonOemPartClaimAmountTotal;
    },
    nonOemPartAttachmentUpload(index,event){
      this.oem_rows[index].attachment = event.target.files[0];
      this.oem_rows[index].attachmentError = "";
    },
    removeOemItem(index) {
      if(this.oem_rows[index].attachmentPath != null){
        this.deleteAttachment(index,"nonOemPartAttachment"); // only call this function if the attachment is not null
      }
      if (this.oem_rows.length > 1) {
        this.oem_rows.splice(index, 1);
      }
      this.calculateTotalNonOemPartAmount();
    },
    addOemRow() {
      var success = true;
      const latestIndex = this.oem_rows.length - 1;
      this.oem_rows[latestIndex].description_error_message = "";
      this.oem_rows[latestIndex].qty_error_msg = "";
      this.oem_rows[latestIndex].unit_price_error_msg = "";
      this.oem_rows[latestIndex].part_error_msg = "";
      this.oem_rows[latestIndex].attachmentError = "";

      if(this.oem_rows[latestIndex].part.value == "other" && this.oem_rows[latestIndex].description == "" ){
        this.oem_rows[latestIndex].description_error_message = "Description is required for other Part";
        success = false;
      }

      if(this.oem_rows[latestIndex].qty == 0 ){
        this.oem_rows[latestIndex].qty_error_msg = "Quantity should be greater than zero!";
        success = false;
      }

      if(this.oem_rows[latestIndex].unit_price == 0 ){
        this.oem_rows[latestIndex].unit_price_error_msg = "Unit Price should be greater than zero!";
        success = false;
      }

      if(this.oem_rows[latestIndex].part == '' ){
        this.oem_rows[latestIndex].part_error_msg = "Part Needs to be selected!";
        success = false;
      }

      if(this.oem_rows[latestIndex].attachmentRequired && this.oem_rows[latestIndex].attachmentPath == null ){
        this.oem_rows[latestIndex].attachmentError = "Attachment required and needs to be uploaded";
        success = false;
      }

      if(success){
        this.oem_rows.push({
          part: '',
          qty: 0,
          unit_price: 0,
          description: "",
          invoice: 0,
          description_error_message: "",
          qty_error_msg: "",
          unit_price_error_msg: "",
          attachment: null,
          attachmentError: "",
          attachmentPath: null,
          attachmentRequired: false,
        });
      }
    },
    populateData(){
      this.oem_rows = this.lineItemData;
      this.nonOemPartClaimAmountTotal = this.nonOemPartClaimAmountTotalProp;
    },
    prepareDataForUpdating(){
      this.oem_rows.forEach((row) => {
        delete row.attachment;
      });
      const lineItemData = {
        netTotalAmount: this.netTotalAmount,
        oemRows: this.oem_rows,
        attachmentRequired: this.attachmentRequired,
        nonOemPartClaimAmountTotal: this.nonOemPartClaimAmountTotal,
        claimId: this.claimId,
      };
      return lineItemData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/non-oem-line-items",
          type: "POST",
          data: {
            lineItemData: lineItemData,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("non_oem_line_items");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvNonOemLineItemsSection.vue